<template>
  <div>
    <div class="settings-box">
      <div class="section-title">
        <i class="far fa-user pr-1" />
        {{ $t('settings.forms.payerForms') }}
      </div>
      <FormSettings
        type="PayerUpdate"
      />
    </div>

    <div class="settings-box">
      <div class="section-title">
        <i class="fa-regular fa-file-contract pr-1" />
        {{ $t('settings.forms.registerForms') }}
      </div>
      <FormSettings
        type="Public"
      />
    </div>

    <div class="settings-box">
      <div class="section-title">
        <i class="far fa-store pr-1" />
        {{ $t('settings.forms.shopForms') }}
      </div>
      <FormSettings type="ShopListing" />
    </div>
  </div>
</template>

<script>
import FormSettings from '@/components/forms/FormSettings';

export default {
  components: {
    FormSettings,
  },
  created() {
    this.$emit('page', 'forms');
  },
};
</script>
